export const getLocalizedProp = <T>(
  prop: (Record<string, T> & { default: string }) | undefined,
  locale: string | null,
) => {
  if (!prop) return prop ?? null;

  const localizedProp = locale && prop[locale];

  return localizedProp ?? prop.default;
};

export const localizePrice = (price: number) => {
  return price.toLocaleString(document.documentElement.lang, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export function getCookieValue(name: string) {
  return (
    document.cookie
      .split("; ")
      .find((cookie) => cookie.startsWith(`${name}=`))
      ?.split("=")[1] ?? null
  );
}
